import { render, staticRenderFns } from "./chart-register-status.vue?vue&type=template&id=80aaa6be&scoped=true&lang=pug&"
import script from "./chart-register-status.vue?vue&type=script&lang=ts&"
export * from "./chart-register-status.vue?vue&type=script&lang=ts&"
import style0 from "./chart-register-status.vue?vue&type=style&index=0&id=80aaa6be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80aaa6be",
  null
  
)

export default component.exports